module.exports = __webpack_public_path__ + "static/media/fb-create-adaccount-9.bd3e8872.svg";